<template>
  <div>
    <el-button icon="el-icon-s-tools" type="text" class="item-btn" @click="handleEdit"/>
    <el-dialog
        :title="`设置【${form.type_name}】乙方`"
        :visible.sync="show"
        center
        custom-class="store-container"
        append-to-body
    >
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item label="默认承接乙方：" prop="default_company_id">
          <company-select :company-id.sync="form.default_company_id" history style="width: 100%"/>
        </el-form-item>
        <el-form-item label="允许指派乙方：" prop="company_ids">
          <company-select :company-id.sync="form.company_ids" history un-collapse-tags multiple style="width: 100%"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <button-submit button-txt="确 定" type="primary" @click.native.prevent="handleSubmit"/>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {saveCompanyOt} from "@/api/company";
import CompanySelect from "@/views/adOrder/components/companySelect.vue";

const Model = {
  project_type: null,
  type_name: null,
  default_company_id: null,
  company_ids: [],
}
const rules = {
  company_ids: [{required: true, message: '必填', trigger: 'change'}],
}

export default {
  name: 'OrderCompanySave',
  components: {CompanySelect},
  props: {
    obj: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      rules,
      show: false,
      form: {...{}, ...Model}
    }
  },
  methods: {
    handleEdit: function () {
      this.form = {...{}, ...this.obj}
      this.show = true
    },
    handleSubmit: function () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const {success, message} = await saveCompanyOt(this.form)
          if (!success) {
            this.$message.error(message || '系统服务异常')
            return
          }
          this.show = false
          this.$message.success('操作成功')
          this.$emit('success')
        } else {
          return false
        }
      })
    }
  }
}

</script>
<style lang="scss">
.store-container {
  border-radius: 20px;
  width: 500px;
}
</style>
